import { BrandImage } from "../brand-image";
import { StyledSideBar } from './dashboard-sidebar.style'
import { Backdrop } from '../backdrop'
import { useState } from 'react'
import NavLinkGroup from './nav-link-group'

const DashboardSidebar = (props) => {
    const [compact, setCompact] = useState(0)
    return (
        <>
            <Backdrop visible={props.visible} onClick={props.close} />
            <StyledSideBar compact={compact} {...props}>
                <div style={{ padding: "3.5rem 3rem" }}>
                    <BrandImage width="14.48rem" close={props.close} compact={compact} setCompact={setCompact} />
                </div>
                <NavLinkGroup compact={compact} setCompact={setCompact} />
            </StyledSideBar>
        </>
    )
}

export { DashboardSidebar }
